import React, { Component } from 'react';
import T from 'prop-types';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import Draggable from 'react-draggable';
import SegmentTable from './SegmentTable';
import SelectedSegmentsTable from './SelectedSegmentsTable';
import SelectedSegmentsGrid from './SelectedSegmentsGrid';
import { Button as AntdBtn, Icon as AntIcn, Switch, Row } from 'antd';
import { Resizable, ResizableBox } from 'react-resizable';
import 'react-resizable/css/styles.css';

class RightBottomSideNav extends Component {
    constructor() {
        super();
        this.state = {
            height: 388,
            width: 306,
            iconType: "profile", // table / profile
            segmentTableDivStyle: { display: "none" },
            segmentGridDivStyle: { display: "block" }
        }
        // this.height = 388;
        this.onResize = this.onResize.bind(this);
        this.selectedsegmentsgrid = React.createRef();
    }

    updateRightBottomSideNavHeight(theScrollYHeight){
        // this.setState({ height: theScrollYHeight+85 });
        this.height = theScrollYHeight + 85;
    }

    getSelectedSegmentId() {
        for (var i = 0; i < this.props.schedulesBrief.length; i++) {
            if (this.props.schedulesBrief[i].selected) {
                window.document.getElementById("right_bottom_btn_manifest_left").children[1].textContent = "Manifest (" + this.props.schedulesBrief[i].res_num + ")"
                return this.props.schedulesBrief[i].res_num;
            }
        }
        return "";
    }

    onResize(event, { element, size }) {
        // this.setState({ height: size.height });
        this.height = size.height;
    }

    setFindBest(theData) {
        // this.selectedsegmentsgrid.current.setFindBest(theData);
        this.selectedsegmentsgrid.current.ref.current.setFindBest(theData);
    }

    clearFindBest(){
        // this.selectedsegmentsgrid.current.clearFindBest();
        this.selectedsegmentsgrid.current.ref.current.clearFindBest();
    }

    handleTableGridSwitch(e) {
        console.log(e);
        if (this.state.iconType === "table") {
            this.setState({ iconType: "profile", segmentTableDivStyle: { display: "none" }, segmentGridDivStyle: { display: "block" }, width: 700 });
        } else {
            this.setState({ iconType: "table", segmentTableDivStyle: { display: "block" }, segmentGridDivStyle: { display: "none" }, width: 306 });
        }
    }

    render() {
        // this.initTrips();
        return (
            <Draggable
                // axis="y"
                // bounds="parent"
                handle=".handle"
                defaultPosition={{ x: 0, y: 0 }}
                position={null}
                grid={[25, 25]}
                onStart={this.handleStart}
                onDrag={this.handleDrag}
                onStop={this.handleStop}
            >

                <Resizable className="resizable_right_bottom_nav" id="myRightBottomNav" height={this.state.height} width={this.state.width} onResize={this.onResize} minConstraints={[306, 266]} maxConstraints={[700, window.innerHeight-80]} hidden>

                    <div className="resizable_right_bottom_nav" style={{ height: this.state.height + 'px' }} >
                        {/* <div style={{ width: "100%", height: 30, backgroundColor: "rgba(255, 255, 255,0.8)", cursor: "pointer" }} className="handle">
                            <AntdBtn type="primary" onClick={(e) => this.props.handleRightBottomBtnManifest(e)} style={{ float: "center" }}>Manifest ({this.getSelectedSegmentId()})<AntIcn type="right" /></AntdBtn>
                        </div>
                        <SelectedSegmentsTable schedulesBrief={this.props.schedulesBrief} schedules={this.props.schedules} scrollY={this.state.height-33} updateStopSelection={this.props.updateStopSelection}/> */}
                        <div style={{ width: "100%", height: 30, backgroundColor: "rgba(255, 255, 255,0.8)", cursor: "pointer" }} className="handle">
                            <Row type="flex" justify="space-around" align="middle" style={{ width: "80%", marginLeft: "20%" }}>
                                <AntdBtn type="primary" onClick={(e) => this.props.handleRightBottomBtnManifest(e)} >Manifest ({this.getSelectedSegmentId()})<AntIcn type="right" /></AntdBtn>
                                {/*<Switch size="small" defaultChecked />*/}
                                <AntIcn type={this.state.iconType} style={{ fontSize: 18, color: '#08c' }} onClick={(e) => this.handleTableGridSwitch(e)} />
                                {/*<AntIcn type="profile" hidden={true}/>*/}
                            </Row>
                        </div>
                        <div style={this.state.segmentTableDivStyle}>
                            <SelectedSegmentsTable schedulesBrief={this.props.schedulesBrief} schedules={this.props.schedules} scrollY={this.state.height - 33} updateStopSelection={this.props.updateStopSelection} updateStopSelections={this.props.updateStopSelections} updateRightBottomSideNavHeight={this.updateRightBottomSideNavHeight.bind(this)} />
                        </div>
                        <div style={this.state.segmentGridDivStyle}>
                        <SelectedSegmentsGrid ref={this.selectedsegmentsgrid} schedulesBrief={this.props.schedulesBrief} schedules={this.props.schedules} scrollY={this.state.height - 70} updateStopSelection={this.props.updateStopSelection} updateStopSelections={this.props.updateStopSelections} updateRightBottomSideNavHeight={this.updateRightBottomSideNavHeight.bind(this)}
                                userName={this.props.userName} selectedDate={this.props.selectedDate} GSENodeJsUrl={this.props.GSENodeJsUrl} QRydeMappBaseUrl={this.props.QRydeMappBaseUrl}
                                updateStopsReorder={this.props.updateStopsReorder} />
                        </div >
                    </div >
                </Resizable>
            </Draggable>
        );
    }
}

export default RightBottomSideNav;



// WEBPACK FOOTER //
// ./src/Componets/RightBottomSideNav.js